import { createPortal } from 'preact/compat';
import useAgeGate from "@/hooks/useAgeGate";
import useUpdateCheckout from "@/hooks/useUpdateCheckout";
import ChevronRight from "@/icons/chevron-right.svg";
import LocationSelectorItem from "@/components/LocationSelectorItem";

function AgeGate() {
	const { yesText, noText, sanitizedContent, step, setStep, stepState, setStepState, showWarning, setShowWarning, allStates, filteredLocations, closeAgeGate, setDutchieRetailerAndFulfillment } = useAgeGate();
	const { updateCheckoutType } = useUpdateCheckout();
	const target = document.querySelector(".cp-age-gate-steps");

	let defaultRetailer;
	if ( ageGate.defaultRetailer ) {
		defaultRetailer = dutchie.retailers.find((retailer) => retailer.post_id === ageGate.defaultRetailer.ID);
	}

	const stepTwo = () => {
		if ( ageGate.skipStepTwo && defaultRetailer ) {
			setDutchieRetailerAndFulfillment(defaultRetailer, "PICKUP");
			closeAgeGate();
		} else {
			setStep(2);
		}
	}

	if ( !target ) {
		return null;
	}

	return createPortal(
		<>
			{step === 1 ? (
				<div className="cp-age-gate-step-one cp-age-gate-step">
					<div dangerouslySetInnerHTML={{ __html: sanitizedContent }}></div>
					<div className="cp-age-gate-buttons">
						<button className="btn-white" onClick={() => stepTwo() }>
							{yesText}
						</button>
						<button onClick={() => setShowWarning(true) }className="btn-white-outline">
							{noText}
						</button>
					</div>

					{showWarning && (
						<p className="cp-age-gate-warning is-visible">
							You are not old enough to view this website.
						</p>
					)}
				</div>
			) : step === 2 ? (
				<div className="cp-age-gate-step-two cp-age-gate-step">
					<p>Where would you like to shop?</p>
					<div className="age-gate-state-list">
					{allStates.map((stateName) => (
						<button
							key={stateName}
							onClick={() => {
								setStep(3);
								setStepState(stateName);
							}}
							className="btn-reset location-selector-item"
						>
							<h3>Shop {stateName}</h3>
							<ChevronRight />
						</button>
					))}
					</div>
				</div>
			) : step === 3 ? (
				<div className="cp-age-gate-step-three cp-age-gate-step">
					<p>Where would you like to shop?</p>
					<button aria-label="Back" className="btn-reset cp-age-gate-back-btn" onClick={() => setStep(2)}>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" fill="none"><path fill="#F7F5E1" d="m6 12 1.413-1.413-4.587-4.586 4.587-4.587L6 0 0 6l6 6Z"/></svg>
						<span>Back</span>
					</button>
					<div className="filtered-locations-list">
						{filteredLocations.map((retailer) =>
							retailer.hidden !== true ? (
								<LocationSelectorItem 
								key={retailer.id} 
								retailer={retailer} 
								onHandleChange={updateCheckoutType} 
								closeAgeGate={closeAgeGate} 
								setDutchieRetailerAndFulfillment={setDutchieRetailerAndFulfillment}
								/>
							) : null
						)}
					</div>
				</div>
			) : null}
		</>,
		target
	);
}
export default AgeGate;